import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';

import { TriggerAction } from '@shared/actions';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { CornerstoneService } from '@viewer/cornerstone.service';
import { BaseToolComponent } from '../base-tool/base-tool.component';
import { KeyInteractionService } from 'src/app/interaction';
import {
  HotKey,
  HotKeySettings,
  ResetTransparencyComponentKeyActionName,
  ResetTransparencyComponentKeyActionNameList,
} from '@viewer/data';

@Component({
  selector: 'app-reset-transparency',
  templateUrl: './reset-transparency.component.html',
  styleUrls: ['./reset-transparency.component.scss'],
})
export class ResetTransparencyComponent
  extends BaseToolComponent
  implements OnInit, OnDestroy
{
  @Input() useHotKeys = true;

  public resetAction!: TriggerAction;

  private _unsubscribe$ = new Subject<void>();

  constructor(
    private _stateManagerService: StateManagerProjectService,
    private _cornerstoneService: CornerstoneService,
    private _keyInteractionService: KeyInteractionService
  ) {
    super(_stateManagerService);
  }

  ngOnInit(): void {
    this.resetAction = new TriggerAction(
      'reset-transparency',
      'Reset Transp.',
      this._onResetTranspBtnClick.bind(this)
    );

    this.resetAction.isEnable = () => this.isDisabled$.pipe(map((x) => !x));
    if (this.useHotKeys) {
      this._initializeHotKeys();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();

    if (this.useHotKeys) {
      this._keyInteractionService.removeKeySettingsList([
        ...ResetTransparencyComponentKeyActionNameList,
      ]);
    }
  }

  private _onResetTranspBtnClick(): void {
    this._cornerstoneService.resetMaskOpacity();
  }

  private _initializeHotKeys(): void {
    this._keyInteractionService
      .initializeHotKey(
        HotKey.T,
        new HotKeySettings<ResetTransparencyComponentKeyActionName>({
          keyActionName: 'ResetTransparencyTrigger',
        })
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this.resetAction.trigger();
      });
  }
}
